export interface WorkflowStep {
  path: string;
  label: string;
  icon: string;
  enabled: boolean;
}

export const WORKFLOW_STEPS: WorkflowStep[] = [
  { path: '/upload', label: 'Upload Data', icon: 'cloud_upload', enabled: true },
  { path: '/discovery', label: 'Data Discovery', icon: 'search', enabled: true },
  { path: '/interval', label: 'Interval Builder', icon: 'straighten', enabled: true },
  { path: '/clustering', label: 'Clustering', icon: 'scatter_plot', enabled: true },
  { path: '/normalization', label: 'Normalization', icon: 'tune', enabled: true },
  { path: '/export', label: 'Download Results', icon: 'download', enabled: true },
];